import { darkTheme } from '../../../lib/tokens';
import type { PipelineFact } from '../data/types';

interface FactsStripProps {
  facts: PipelineFact[];
  /** Groessere Schrift fuer den Praesentationsmodus. */
  large?: boolean;
}

/**
 * Kennzahlen mit Herkunft. Die Quelle steht klein unter dem Wert statt in
 * einem Tooltip — im Vortrag zeigt man auf eine Zahl und wird nach ihrer
 * Herkunft gefragt; dann will man sie sehen, nicht erst hovern muessen.
 */
export function FactsStrip({ facts, large = false }: FactsStripProps): JSX.Element {
  return (
    <dl
      className={`grid gap-3 ${large ? 'grid-cols-2 lg:grid-cols-3' : 'grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'}`}
    >
      {facts.map((fact) => (
        <div
          key={fact.label}
          className="rounded-md border p-3"
          style={{ background: darkTheme.colors.bgSurface, borderColor: darkTheme.colors.borderSubtle }}
        >
          <dt className={`text-text-tertiary ${large ? 'text-sm' : 'text-[11px]'} uppercase tracking-wider`}>
            {fact.label}
          </dt>
          <dd
            className={`mt-1 font-bold text-text-primary ${large ? 'text-3xl' : 'text-xl'}`}
            style={{ color: darkTheme.colors.accentLight }}
          >
            {fact.value}
          </dd>
          {fact.hint && (
            <p className={`mt-1 text-text-secondary ${large ? 'text-sm' : 'text-xs'}`}>{fact.hint}</p>
          )}
          <p className={`mt-2 text-text-tertiary ${large ? 'text-xs' : 'text-[10px]'} font-mono leading-snug`}>
            {fact.source}
          </p>
        </div>
      ))}
    </dl>
  );
}
